import React, { useState } from "react";
import { Form, Input, Button, Typography, Card, Divider } from "antd";
import { useForm } from "antd/es/form/Form";

const ForgotPasswordWorker = () => {
  const [form] = useForm();
  const [isOtpView, setIsOtpView] = useState(false);

  const onSubmitEmail = (values) => {
    // Handle email submission here
  };

  const onSubmitOtp = (values) => {
    // Handle OTP submission here
  };

  return (
    <>
      <Card
        style={{
          maxWidth: 450,
          margin: "auto",
          marginTop: 25, // Reduced margin to bring the title closer to the top
          padding: "24px",
          boxShadow: "0px 5px 15px hsla(220, 30%, 5%, 0.05)",
        }}>
        <Typography.Title
          level={2}
          style={{ textAlign: "center", marginBottom: 30 }}>
          Şifremi Unuttum
        </Typography.Title>

        {/* Conditionally render the email or OTP form */}
        {!isOtpView ? (
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmitEmail}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Form.Item
              label="Email Adresiniz"
              name="email"
              rules={[
                { required: true, message: "Lütfen email adresinizi giriniz" },
                { type: "email", message: "Geçerli bir email giriniz" },
              ]}>
              <Input placeholder="example@example.com" />
            </Form.Item>

            <Button
              onClick={() => {
                setIsOtpView(true);
              }}
              type="primary"
              htmlType="submit"
              block>
              Devam Et
            </Button>
          </Form>
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmitOtp}
            style={{
              display: "flex",
              flexDirection: "column",
              columnGap: 20,
              gap: 8,
              alignItems: "center",
            }}>
            <Typography.Text
              style={{
                fontSize: 15,
                display: "block",
                textAlign: "center",
                marginBottom: 20,
              }}>
              Lütfen Mailinize Gelen Kodu Giriniz
            </Typography.Text>
            <Form.Item
              name="otp"
              rules={[
                { required: true, message: "Lütfen OTP kodunu giriniz" },
              ]}>
              <Input.OTP size="large" length={6} />
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              Onayla
            </Button>
          </Form>
        )}

        <Divider />
        <Typography.Text style={{ display: "block", textAlign: "center" }}>
          Giriş Sayfasına Dön
          <Button type="link">Giriş Yap</Button>
        </Typography.Text>
      </Card>
    </>
  );
};

export default ForgotPasswordWorker;
